export default __webpack_public_path__ + "static/media/bus-side-view-grey.51e22757.svg";